import type { Denticao } from "@bookdental/schemas";
import { cn } from "@/lib/cn";

const OPCOES: { valor: Denticao; rotulo: string }[] = [
  { valor: "permanente", rotulo: "Permanente" },
  { valor: "decidua", rotulo: "Decídua" },
];

/** Troca a arcada visível; a seleção das duas dentições continua guardada (dentição mista). */
export function SeletorDeDenticao({
  valor,
  onMudar,
  contagem,
}: {
  valor: Denticao;
  onMudar: (d: Denticao) => void;
  /** Dentes marcados em cada dentição — aparece ao lado do nome quando há algum. */
  contagem?: Partial<Record<Denticao, number>>;
}) {
  return (
    <div
      role="radiogroup"
      aria-label="Dentição"
      className="grid w-full grid-cols-2 rounded-md border border-zinc-200 p-0.5 dark:border-border"
    >
      {OPCOES.map((o) => {
        const ativo = o.valor === valor;
        const n = contagem?.[o.valor] ?? 0;
        return (
          <button
            key={o.valor}
            type="button"
            role="radio"
            aria-checked={ativo}
            onClick={() => onMudar(o.valor)}
            className={cn(
              "rounded px-2 py-1 text-xs font-medium transition-colors",
              ativo
                ? "bg-brand-50 text-brand-700 dark:bg-primary/10 dark:text-primary"
                : "text-zinc-500 hover:text-zinc-800",
            )}
          >
            {o.rotulo}
            {n > 0 && <span className="ml-1 text-[10px] text-zinc-400">({n})</span>}
          </button>
        );
      })}
    </div>
  );
}
